export default "__VITE_PUBLIC_ASSET__5058c246__"